import axios from 'axios';

interface ErrorResponse {
  status: number;
  data?: {
    message?: string;
  };
}

const apiUrl = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let customErrorMessage = 'エラーが発生しました。';

    if (error.response) {
      switch (error.response.status) {
        case 400:
          customErrorMessage =
            'バリデーションエラー: 入力パラメータを確認してください。';
          break;
        case 401:
          customErrorMessage = '権限がありません。';
          localStorage.removeItem('token');

          // Only redirect if not already on the login page
          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login';
          }
          break;
        case 404:
          customErrorMessage = 'データがありません。';
          break;
        case 409:
          customErrorMessage =
            'このユーザーIDは既に使用されています。別のユーザーIDを登録してください';
          break;
        case 422:
          customErrorMessage = '処理できません。';
          break;
        case 500:
          customErrorMessage = 'サーバーエラー';
          break;
        default:
          customErrorMessage = 'Unexpected error. Please try again.';
      }
    } else if (error.request) {
      customErrorMessage = 'Network error: No response received.';
    } else {
      customErrorMessage = error.message || 'An unknown error occurred.';
    }

    const newError = new Error(customErrorMessage) as Error & {
      response?: ErrorResponse;
    };
    newError.response = error.response;
    return Promise.reject(newError);
  },
);

export default api;
